import React from 'react'
import PropTypes from 'prop-types'

import { Container } from 'ui/acro'

import CategoryCard from './CategoryCard'

const CategoriesResponsive = ({ categories }) => {
  return (
    <Container
      width='100%'
      centerProps={{ flexDirection: 'row', justifyContent: 'space-between' }}
    >
      {categories &&
        categories.map((item, index) => <CategoryCard {...item} key={index} />)}
    </Container>
  )
}

CategoriesResponsive.propTypes = {
  categories: PropTypes.array
}

export default CategoriesResponsive
